<template>
    <div>

      <ComIndex  :orderType="13" exportTitle="分级升级培训订单"/>

    </div>
</template>

<script>
import ComIndex from '../commonIndex'
export default {
  components: {
    ComIndex
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }

}
</script>
<style  scoped>

</style>